import styled, { css } from 'styled-components';
import { media } from '~constants/media';

export const Block = styled.div<{ desktopSmallView?: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  row-gap: 22px;
  margin-top: 22px;

  ${({ desktopSmallView }) => css`
    ${media.lg`
      ${!desktopSmallView &&
        `
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(1, 1fr);
      `}
    `}
  `}
`;
